export function getFileName(file: File | string) {
  if (file instanceof File) {
    return file.name;
  }
  const parts = file.split(/\//g);
  return parts[parts.length - 1];
}
